<template>
  <div>
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminHollidaysList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      items: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Starts",
          align: "start",
          sortable: false,
          value: "starts_on",
          filterable: false,
        },
        {
          text: "Ends",
          align: "start",
          sortable: false,
          value: "ends_on",
          filterable: false,
        },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Holidays.get_holidays(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading holidays on admin list", errors);
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/admin/hollidays/list/view/" + item.id);
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Hollidays List",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Holidays",
          disabled: false,
          href: "/admin/hollidays",
        },
        {
          text: "List",
          disabled: true,
          href: "/admin/hollidays/list",
        },
      ],
    });
    this.load_items();
  },
};
</script>